/// <amd-module name="WidgetCommon/TestUtils/TestUtils" />
/**
 * Utility functions for authoring L0 tests for widgets.
 */

import { WidgetPresentationMode, WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";

export function getTestProps(settings?: string): WidgetProps {
    return {
        contributionId: "widget contribution id",
        name: "name of widget",
        size: {
            width: 100,
            height: 200
        },
        settings: settings || null,
        settingsVersion: {
            major: 1,
            minor: 2,
            patch: 3
        },
        showLoadAnimations: true,
        openLinksInNewTab: true,
        avoidShowingModalUI: false,
        teamContext: {
            id: "8a23d601-97af-48e9-8c93-bc2d6abec509",
            name: "Test team"
        },
        presentationMode: WidgetPresentationMode.dashboardView,
        onWidgetLoaded: () => {},
        onConfigure: () => {},
        setMenuColorMode: () => {},
        setCustomContextMenuItems: () => {}
    };
}
